import { render, staticRenderFns } from "./CloudEditor.vue?vue&type=template&id=3dc53f3e&scoped=true&"
import script from "./CloudEditor.vue?vue&type=script&lang=js&"
export * from "./CloudEditor.vue?vue&type=script&lang=js&"
import style0 from "./CloudEditor.vue?vue&type=style&index=0&id=3dc53f3e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc53f3e",
  null
  
)

export default component.exports